import { setBlockTracking as _setBlockTracking, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid group-page" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "card mb-2" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "app version", -1)
const _hoisted_12 = { class: "input-group-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[0] || (
                  _setBlockTracking(-1),
                  _cache[0] = _createElementVNode("h4", null, [
                    _createTextVNode(_toDisplayString(_ctx.group?.Name), 1)
                  ]),
                  _setBlockTracking(1),
                  _cache[0]
                )
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.group.SvtAppVersion) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.group.SvtAppVersion]
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-dark",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                    }, " Save ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}